/**
 * Story 24.18 — the accessible name of a nav control that carries the
 * waiting count ("Tasks, 2 waiting").
 *
 * The number is the REAL count even when the `CountBadge` reads "9+", and the
 * name falls back to the bare label exactly when the badge hides (0, loading,
 * error): `formatCount` is the one rule for both.
 */
import { formatCount } from '@/components/ui/count-badge';

export function waitingLabel(name: string, count: number | null | undefined): string {
  if (formatCount(count) === null) return name;
  return `${name}, ${Math.floor(count as number)} waiting`;
}
